import React, { useState, useEffect, useRef } from 'react';
import { FooterContainer, IconContainer, ClinicContainer, ClinicInner, OpenCloseText, SecContainer, BackContainer } from './Styles';
import { ReactComponent as Left } from '../../../assets/images/textalign-left.svg';
import { ReactComponent as Right } from '../../../assets/images/slider-vertical.svg';
import SwitchComponent from 'src/components/shared/Form/Switch';
import RightSidebar from '../RIghtSidebar/RightSidebar';
import { ReactComponent as LeftArrow } from '../../../assets/images/arrow-left 2.svg';
import { Box, Typography } from '@mui/material';
import { Navigate } from 'react-router-dom';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import toast from 'src/utils/toast';
import { postAvailabilityRequest, fetchAvailabilityRequest } from 'src/modules/app/store/appActions';
import { getUserFromToken } from 'src/DecodeToken';
import storage from 'src/utils/storageUtils';

function Footer({ isPermanentOpen, toggleSidebar }) {
    const [clinicStatus, setClinicStatus] = useState(true);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const pathParts = location.pathname.split('/').filter(Boolean);
    const routeClinicId = (pathParts.length >= 1 && pathParts[0].length === 24) ? pathParts[0] : null;
    const effectiveClinicId = clinic.currentClinic?.id || clinic.clinicId || routeClinicId || storage.get('CLINIC_ID') || clinics[0]?.id;
    const [isAcceptingTokens, setIsAcceptingTokens] = useState(() => {
        const cached = effectiveClinicId ? storage.get(`CLINIC_OPEN_${effectiveClinicId}`) : null;
        return cached === 'yes';
    });
    const doctorId = getUserFromToken();


    const clinic = useSelector((state) => state.app.clinics);

    const clinics = clinic?.data || [];
    console.log("here is toggle sidebar", isPermanentOpen);
    const isFirstLoad = useRef(true);
    // Fetch availability on mount
    useEffect(() => {
        if (effectiveClinicId) {
            dispatch(
                fetchAvailabilityRequest(
                    effectiveClinicId,
                    (res) => {
                        const tokenStatus = res?.clinicSettings?.acceptingTokens === 'yes';
                        setIsAcceptingTokens(tokenStatus);
                        storage.set(`CLINIC_OPEN_${effectiveClinicId}`, tokenStatus ? 'yes' : 'no');
                        isFirstLoad.current = false;
                    },
                    (err) => {
                        console.error("Error fetching availability", err);
                    }
                )
            );
        }
    }, [effectiveClinicId, dispatch]);

    useEffect(() => {
        if (effectiveClinicId) {
            storage.set('CLINIC_ID', effectiveClinicId);
        }
    }, [effectiveClinicId]);


    const handleToggle = () => {
        const updatedValue = !isAcceptingTokens;
        setIsAcceptingTokens(updatedValue);
        if (effectiveClinicId) {
            storage.set(`CLINIC_OPEN_${effectiveClinicId}`, updatedValue ? 'yes' : 'no');
        }

        if (effectiveClinicId) {
            const data = {
                clinic: effectiveClinicId,
                acceptingTokens: updatedValue ? 'yes' : 'no',
                acceptingAppointments: updatedValue ? 'yes' : 'no',
            };

            dispatch(postAvailabilityRequest(
                data,
                (res) => {
                    console.log("Availability updated successfully", res?.data);
                    toast.success(res?.message || (updatedValue ? "Clinic Opened" : "Clinic Closed"));
                },
                (err) => {
                    console.error("Error updating availability", err);
                }
            ));
        }
    };

    return (
        <>
            <FooterContainer >
                <SecContainer >
                    {location.pathname.includes('/appointment/Patients/') && (
                        <BackContainer onClick={() => navigate(`${clinic.currentClinic?.id}/${doctorId}/appointment`)}>
                            <LeftArrow width={24} height={24} />
                        </BackContainer>
                    )}
                    <IconContainer onClick={toggleSidebar}>
                        <Left />
                    </IconContainer>
                </SecContainer>
                <SecContainer>


                    <ClinicContainer>

                        <ClinicInner >
                            <OpenCloseText> Clinic:</OpenCloseText>

                            <OpenCloseText>
                                Open
                            </OpenCloseText>
                            <SwitchComponent
                                checked={isAcceptingTokens}
                                onChange={handleToggle}
                                sx={{
                                    margin: 0,
                                    padding: 0,
                                }}
                            />

                            <OpenCloseText >
                                Close
                            </OpenCloseText>
                        </ClinicInner>
                    </ClinicContainer>

                    <IconContainer>
                        <Right
                            onClick={() => setSidebarOpen(true)}
                        />
                    </IconContainer>
                </SecContainer>
            </FooterContainer>
            <RightSidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        </>
    )
}
export default Footer